var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aboutSoftware_x5F_SVG",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    enableBackground: "new 0 0 17 17",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.64,15.389l-0.013-0.003l-3.2-0.854l-0.022-0.014l-2.826-2.804l-0.014-0.024l-0.86-3.228V8.438 l0.838-3.294l0.016-0.025l3.363-2.93l0.021-0.011l2.684-0.663L8.67,1.523l0.02,0.039v13.774l-0.02,0.039L8.64,15.389z  M5.465,14.438l3.125,0.836V1.627L5.979,2.271L2.637,5.184L1.805,8.449l0.854,3.201L5.465,14.438z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.64,13.124l-0.03-0.013l-0.02-0.038V3.826l0.02-0.039l0.043-0.009l1.802,0.445l0.021,0.011l2.256,1.967 l0.017,0.025l0.563,2.211v0.025l-0.578,2.167l-0.014,0.023l-1.896,1.881l-0.022,0.014l-2.148,0.574L8.64,13.124z M8.689,3.891 v9.118l2.073-0.555l1.877-1.864l0.571-2.141l-0.556-2.183l-2.237-1.949L8.689,3.891z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1C75BC",
    points: "9.32,15.146 9.271,15.107 9.311,15.048 10.27,14.854 10.329,13.948 10.363,13.902 10.708,13.8  10.762,13.814 11.37,14.521 12.421,13.866 12.104,12.948 12.126,12.889 12.443,12.71 12.491,12.708 13.271,13.087 13.961,12.229  13.448,11.521 13.443,11.466 13.609,11.173 13.652,11.146 13.657,11.146 14.65,11.21 15.009,10.174 14.2,9.66 14.18,9.607  14.242,9.302 14.277,9.264 15.232,8.982 15.198,7.899 14.241,7.678 14.203,7.634 14.178,7.341 14.193,7.299 14.997,6.595  14.652,5.632 13.622,5.755 13.616,5.756 13.568,5.723 13.467,5.442 13.473,5.398 13.999,4.587 13.283,3.74 12.398,4.132  12.343,4.121 12.165,3.931 12.152,3.886 12.35,2.967 11.38,2.452 10.667,3.079 10.613,3.088 10.372,2.986 10.342,2.942  10.307,2.061 9.32,1.79 9.285,1.729 9.348,1.693 10.366,1.974 10.402,2.02 10.439,2.906 10.624,2.983 11.34,2.354 11.396,2.348  12.43,2.896 12.454,2.95 12.255,3.881 12.393,4.026 13.275,3.634 13.335,3.646 14.102,4.551 14.104,4.61 13.568,5.432  13.648,5.651 14.682,5.528 14.732,5.561 15.104,6.593 15.089,6.647 14.279,7.357 14.3,7.589 15.259,7.811 15.297,7.857  15.335,9.018 15.3,9.066 14.334,9.352 14.284,9.594 15.096,10.109 15.116,10.169 14.732,11.277 14.684,11.313 13.684,11.251  13.548,11.486 14.063,12.2 14.063,12.264 13.323,13.182 13.264,13.193 12.471,12.811 12.211,12.954 12.527,13.87 12.509,13.93  11.387,14.63 11.322,14.62 10.706,13.905 10.427,13.989 10.365,14.896 10.325,14.941 9.332,15.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1C75BC",
    points: "9.35,11.626 9.301,11.587 9.34,11.525 9.773,11.438 9.801,11.03 9.836,10.984 9.999,10.938  10.051,10.954 10.323,11.271 10.784,10.982 10.641,10.568 10.663,10.508 10.813,10.425 10.859,10.423 11.21,10.592 11.512,10.22  11.279,9.9 11.275,9.848 11.354,9.708 11.398,9.684 11.4,9.684 11.852,9.711 12.007,9.26 11.643,9.027 11.62,8.976 11.65,8.831  11.686,8.793 12.118,8.666 12.104,8.195 11.67,8.095 11.632,8.051 11.619,7.912 11.637,7.87 12.003,7.549 11.854,7.131  11.387,7.186 11.38,7.187 11.333,7.153 11.285,7.021 11.29,6.978 11.527,6.61 11.216,6.24 10.816,6.417 10.759,6.406  10.675,6.316 10.663,6.271 10.751,5.856 10.327,5.631 10.004,5.915 9.952,5.924 9.837,5.876 9.807,5.832 9.789,5.435 9.343,5.312  9.309,5.25 9.369,5.215 9.852,5.348 9.889,5.394 9.904,5.796 9.962,5.819 10.287,5.533 10.343,5.526 10.831,5.785 10.855,5.84  10.766,6.267 10.809,6.312 11.209,6.134 11.268,6.146 11.63,6.574 11.633,6.634 11.389,7.011 11.413,7.082 11.88,7.027  11.934,7.06 12.107,7.547 12.094,7.602 11.723,7.929 11.729,8.006 12.163,8.106 12.201,8.153 12.221,8.701 12.184,8.751  11.742,8.881 11.727,8.962 12.094,9.195 12.113,9.255 11.934,9.779 11.887,9.813 11.884,9.813 11.427,9.785 11.379,9.868  11.613,10.191 11.611,10.253 11.264,10.686 11.202,10.7 10.84,10.523 10.749,10.575 10.893,10.986 10.87,11.046 10.341,11.378  10.275,11.368 9.996,11.044 9.896,11.073 9.87,11.482 9.83,11.53 9.359,11.626  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.64,15.389l-0.033-0.015l-4.129-3.679l-1.862,0.031H2.613l-0.04-0.02L2.566,11.66l1.127-3.249 L3.74,8.378l0,0l2.406,0.014L6.14,8.32l0.114-1.113L2.568,5.199L2.542,5.157l0.024-0.044l6.01-3.593l0.061,0.007l0.008,0.062 l-2.07,3.482L6.359,7.15l2.316,1.262L8.7,8.468L8.652,8.506l0,0L6.254,8.492l0.292,3.222l2.137,3.599l-0.011,0.063L8.64,15.389z  M4.496,11.598l0.033,0.012l3.902,3.477l-1.978-3.328l-0.007-0.021L6.154,8.491L3.775,8.479l-1.091,3.147L4.496,11.598 L4.496,11.598z M6.246,8.393l2.207,0.012L6.349,7.258l-0.11,1.063L6.246,8.393z M2.693,5.153l3.572,1.945l0.21-2.049l0.007-0.021 l1.975-3.322L2.693,5.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M5.439,14.532L5.426,14.53l-0.033-0.033l-0.967-2.822L3.975,9.684L1.693,8.557L1.665,8.512l0.028-0.045 l2.384-1.131l0.782-2.188L2.594,5.206H2.592l-0.05-0.049l0.049-0.052l2.304-0.059l1.014-2.838l0.045-0.033h0.002L6,2.206 L7.236,5.06l1.42,0.11l0.045,0.041L8.674,5.267l-1.119,0.53l1.143,2.639l-0.015,0.06l-2.696,2.07l2.59,1.279l0.021,0.021h0.004 l0.039,0.018l-0.008,0.07l-3.162,2.567L5.439,14.532z M4.539,11.698l0.925,2.698l3.031-2.461L4.539,11.698z M4.633,11.604 l3.678,0.222l-2.413-1.192L4.633,11.604z M4.09,9.74l0.416,1.837l1.291-0.993L4.09,9.74z M4.061,9.614l1.826,0.901l2.704-2.077 l-1.126-2.6l-3.307,1.57L3.793,8.432L4.061,9.614z M1.83,8.513l2.115,1.045l-0.254-1.12l0.002-0.028L4.029,7.47L1.83,8.513z  M4.966,5.145l-0.761,2.13l3.221-1.527L7.169,5.155l-0.647-0.05L4.966,5.145z M7.281,5.164l0.234,0.541L8.46,5.257L7.281,5.164z  M6.523,5.005l0.601,0.047l-1.165-2.69L5.002,5.044L6.523,5.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M12.201,3.946L12.165,3.93l-0.817-0.879l-0.711,0.041l-0.021-0.004l-0.242-0.102L9.686,2.562L9.318,2.843 L9.264,2.847L9.238,2.799l0.041-0.494L9.271,2.271l0.012-0.025L9.324,1.75l0.051-0.046h0.004l0.045,0.055l-0.037,0.45l0.918-0.245 l0.059,0.026l-0.016,0.062L9.77,2.496l0.648,0.401l0.225,0.094l0.616-0.036l-0.235-0.254l-0.006-0.059l0.043-0.025l0.01,0.001 l0.418,0.085L11.33,2.416l0.02-0.067l0.068,0.02l0.198,0.36l0.8,0.162l0.04,0.053L12.407,2.99l-0.63,0.036l0.468,0.846 L12.23,3.937L12.201,3.946z M11.479,3.043l0.483,0.521l-0.293-0.532L11.479,3.043z M11.202,2.747l0.188,0.201l0.225-0.013 L11.55,2.817L11.202,2.747z M11.68,2.844l0.047,0.085l0.291-0.017L11.68,2.844z M9.374,2.369L9.348,2.694l0.246-0.189L9.374,2.369 z M9.445,2.296L9.68,2.44l0.409-0.315L9.445,2.296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.229,7.387l-0.047-0.033l-0.715-1.911l-0.626-1.168l-0.476-0.14l-0.034-0.063l0.063-0.034l0.381,0.112 l-0.104-0.189l0.014-0.063L12.75,3.9l0.387,0.357l0.202,0.061l-0.303-0.465l0.008-0.063l0.063-0.003l0.984,0.757l0.014,0.063 l-0.059,0.025L13.57,4.491l0.287,0.44L13.85,4.996l-0.066-0.002l-0.699-0.648l-0.109-0.032l0.582,1.087l0.105,0.287l0.556,1.482 l0.237-0.911l-0.768-0.525l-0.013-0.069l0.069-0.014l0.736,0.506l0.006-0.02L14.007,5.68l-0.014-0.053l0.043-0.033l0.644-0.066 l0.043,0.017l0.012,0.045L14.6,6.107l0.489,0.467l0.004,0.068l-0.065,0.01L14.544,6.32l-0.269,1.028l-0.047,0.038l0,0V7.387z  M14.57,6.217L14.57,6.217L14.57,6.217z M14.154,5.683l0.361,0.345l0.104-0.393L14.154,5.683z M13.3,4.41l0.255,0.235 l-0.131-0.198L13.3,4.41z M13.486,4.361l0.332,0.099l-0.537-0.414L13.486,4.361z M12.909,4.19l0.01,0.003L12.9,4.176L12.909,4.19z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.292,9.361l-0.036-0.014l-0.013-0.051l0.346-1.132l-0.376-0.507l0.012-0.07L14.293,7.6l0.333,0.447 l0.097-0.313l0.063-0.033l0.033,0.062L14.7,8.146l0.26,0.352l0.24-0.656l0.047-0.033l0.008,0.001l0.042,0.048l0.038,1.16 l-0.033,0.049l-0.057-0.018l-0.254-0.342l-0.177,0.48l-0.031,0.03l-0.477,0.142L14.292,9.361z M14.663,8.266l-0.297,0.972 L14.73,9.13l0.188-0.519L14.663,8.266z M15.032,8.595l0.196,0.266L15.206,8.12L15.032,8.595z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.688,11.313h-0.002l-0.047-0.037l-0.101-0.357l-0.271,0.348l-0.062,0.015l-0.026-0.058l0.198-0.879 l-0.032-0.117l-0.648,1l-0.069,0.015l-0.015-0.068l0.697-1.075L14.18,9.633l0.034-0.063l0.063,0.035l0.104,0.381l0.123-0.19 l0.063-0.021l0.029,0.059l-0.115,0.508l0.1,0.358l0.447-0.576l0.063-0.015l0.023,0.062l-0.384,1.109L14.688,11.313z  M14.613,10.816l0.078,0.277l0.23-0.674L14.613,10.816z M14.436,10.545l-0.109,0.48l0.18-0.229L14.436,10.545z M14.417,10.111 l0.008,0.024l0.013-0.054L14.417,10.111z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M11.359,14.639l-0.028-0.011l-0.017-0.063l0.236-0.496l-0.463,0.226l-0.061-0.014l-0.344-0.398 l-0.013-0.041l0.024-0.034l1.369-0.816l0.037-0.08l0.021-0.021l0.318-0.178l1.154-0.707l-0.158-0.496l0.033-0.063l0.063,0.031 l0.15,0.473l0.096-0.059l0.063,0.01l0.001,0.063l-0.112,0.138l0.121,0.383l-0.021,0.059l-0.865,0.484l-0.063-0.012V12.95 l0.674-0.818l-1.084,0.664l-0.286,0.16l0.003,0.004l-0.018,0.067l-0.051,0.031l-0.379,0.795l0.6-0.291l0.063,0.019l-0.007,0.063 l-1.024,0.979L11.359,14.639z M11.695,13.999l-0.174,0.365l0.599-0.57L11.695,13.999z M10.8,13.859l0.28,0.326l0.542-0.262 l0.366-0.773L10.8,13.859z M13.659,12.191l-0.509,0.617l0.598-0.336L13.659,12.191z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M9.396,15.146H9.391l-0.039-0.024l-0.164-0.283l0.002-0.053l0.043-0.022h0.004l0.357,0.026l0.747-0.871 l0.07-0.006l0.006,0.069l-0.7,0.816l0.604,0.043l0.046,0.055l-0.05,0.047h-0.004l-0.676-0.051L9.434,15.13L9.396,15.146z  M9.322,14.87l0.08,0.141l0.109-0.127L9.322,14.87z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BC",
    cx: 5.993,
    cy: 2.277,
    r: 0.187
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BC",
    cx: 2.644,
    cy: 5.159,
    r: 0.187
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BC",
    cx: 8.665,
    cy: 5.232,
    r: 0.187
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BC",
    cx: 4.188,
    cy: 7.39,
    r: 0.187
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BC",
    cx: 4.511,
    cy: 11.603,
    r: 0.187
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BC",
    cx: 8.568,
    cy: 15.298,
    r: 0.187
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BC",
    cx: 2.614,
    cy: 11.679,
    r: 0.187
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BC",
    cx: 8.613,
    cy: 8.379,
    r: 0.188
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BC",
    cx: 6.548,
    cy: 5.082,
    r: 0.187
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BC",
    cx: 6.626,
    cy: 13.542,
    r: 0.187
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 3.612,
    transform: "matrix(-0.7089 0.7053 -0.7053 -0.7089 25.3185 -3.09)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.011,
    y: 2.606,
    transform: "matrix(-0.7089 0.7053 -0.7053 -0.7089 20.8174 -3.244)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.136
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.282,
    y: 1.697,
    transform: "matrix(-0.7107 0.7035 -0.7035 -0.7107 17.2363 -3.5575)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.749,
    y: 4.87,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 27.0783 -1.3412)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.008,
    y: 5.592,
    transform: "matrix(-0.7053 0.7089 -0.7089 -0.7053 28.016 -0.328)",
    fill: "#1C75BC",
    width: 0.136,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.915,
    y: 8.536,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 31.6602 4.0929)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.491,
    y: 9.759,
    transform: "matrix(-0.7107 0.7035 -0.7035 -0.7107 31.8177 6.5695)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.597,
    y: 11.126,
    transform: "matrix(-0.7035 0.7107 -0.7107 -0.7035 31.2326 9.3558)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.876,
    y: 12.916,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 31.2763 13.0117)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.311,
    y: 14.517,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 29.7381 16.852)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.311,
    y: 13.884,
    transform: "matrix(-0.7035 0.7107 -0.7107 -0.7035 27.5955 16.3909)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.28,
    y: 15.018,
    transform: "matrix(-0.7035 0.7107 -0.7107 -0.7035 26.6446 19.0552)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.197,
    y: 8.327,
    transform: "matrix(-0.7053 0.7089 -0.7089 -0.7053 28.5703 4.9118)",
    fill: "#1C75BC",
    width: 0.134,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.719,
    y: 12.431,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 27.2529 13.7095)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.288,
    y: 5.196,
    transform: "matrix(-0.7017 0.7125 -0.7125 -0.7017 19.6711 2.2908)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.085,
    y: 8.088,
    transform: "matrix(-0.7053 0.7089 -0.7089 -0.7053 26.5039 5.2924)",
    fill: "#1C75BC",
    width: 0.134,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.62,
    y: 10.486,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 25.7073 10.4591)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.376,
    y: 4.149,
    transform: "matrix(-0.7089 0.7053 -0.7053 -0.7089 20.8214 -0.1607)",
    fill: "#1C75BC",
    width: 0.135,
    height: 0.134
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.256,
    y: 11.518,
    transform: "matrix(-0.7144 0.6998 -0.6998 -0.7144 24.0903 13.3366)",
    fill: "#1C75BC",
    width: 0.134,
    height: 0.134
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BC",
    cx: 8.613,
    cy: 11.866,
    r: 0.188
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/vector5.59551179d30325dac62faae6007a32a6.svg";
export { ForwardRef as ReactComponent };